import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcuser.approve.group.new');
import { RequestList } from "src/libs/request-list";
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-gsdcuser-approve-group-new',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcuser.approve.group.new/view.scss */
/* src/app/portal.gsdcuser.approve.group.new/view.scss: no such file or directory */`],
})
export class PortalGsdcuserApproveGroupNewComponent implements OnInit {
    public requestList = new RequestList('newGroup');
    public loadFailed = false;
    public groupRequests: any[] = [];      // 신규 그룹 생성 요청 데이터를 저장하는 배열
    public loading: boolean = false;       // 로딩 상태를 나타내는 변수
    public is_pi: boolean = false;
    public is_community_rep: boolean = false;
    public is_manager: boolean = false;
    public community_id: string = '';      // 커뮤니티 ID 저장



    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/login");

        // 세션 정보에서 커뮤니티 ID 가져오기
        const session = await wiz.call("get_session");
        this.community_id = session.data.community_id;

        await this.loadApprovalRoles();
        // 요청 데이터를 로드
        await this.loadGroupRequests();
    }

    public async loadApprovalRoles() {
        const { code, data } = await wiz.call('get_approval_roles');
        if (code === 200) {
            this.is_pi = data.is_pi;
            this.is_community_rep = data.is_community_rep;
            this.is_manager = data.is_manager;
        }
        await this.service.render();
    }

    // 그룹 생성 요청 데이터를 로드하는 함수
    public async loadGroupRequests() {
        this.loading = true;
        this.loadFailed = false;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('get_group_requests');
            if (code !== 200 || !Array.isArray(data)) throw new Error('load');
            this.groupRequests = data;
            this.requestList.setRows(data);
        } catch (_) {
            this.loadFailed = true;
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async changePage(page: number) {
        this.requestList.changePage(page);
        await this.service.render();
    }

    // 승인 처리 함수
    public processing = false;
    public async approveRequest(request_id: string) { await this.processRequest(request_id, true); }
    public async rejectRequest(request_id: string) { await this.processRequest(request_id, false); }

    private async processRequest(request_id: string, approve: boolean) {
        if (this.processing) return;
        this.processing = true;
        let submitted = false;
        let message = '';
        let succeeded = false;
        try {
            const row = this.groupRequests.find(request => request.id === request_id);
            const managerFinal = approve && row?.manager_final_approval === true;
            const skip = managerFinal && row?.manager_skip_representative === true;
            const confirmation = skip ? ('커뮤니티 대표 승인을 생략하고 연구그룹을 생성하며 신청자를 그룹 대표(PI)로 지정하시겠습니까?') : '승인하시겠습니까?';
            const confirmed = approve
                ? await this.service.alert.success(confirmation, '취소')
                : await this.service.alert.error('거절하시겠습니까?', '취소');
            if (!confirmed) return;
            submitted = true;
            this.service.loading.show();
            // Reuse the management endpoint for final approval and its retry/audit logic.
            const payload: any = { request_id };
            if (managerFinal) payload.tab = 'newGroup';
            if (skip) payload.skip_representative = '1';
            const api = managerFinal ? wiz.app('portal.gsdcadmin.request') : wiz;
            const action = managerFinal ? 'approve_request' : (approve ? 'approve_group_request' : 'reject_request');
            const { code, data } = await api.call(action, payload, { timeout: 135000 });
            succeeded = code === 200;
            message = typeof data === 'string' ? data : data?.message;
            if (!message) message = succeeded
                ? (approve ? '요청이 승인되었습니다.' : '요청이 거절되었습니다.')
                : '요청 처리에 실패했습니다. 목록을 확인한 후 다시 시도해주세요.';
        } catch (_) {
            message = '처리 결과를 확인하지 못했습니다. 목록을 확인한 후 다시 시도해주세요.';
        } finally {
            this.service.loading.hide();
            try {
                if (submitted) await this.loadGroupRequests();
                if (message) {
                    if (succeeded) await this.service.alert.success(message);
                    else await this.service.alert.error(message);
                }
            } finally {
                this.processing = false;
                await this.service.render();
            }
        }
    }
}

export default PortalGsdcuserApproveGroupNewComponent;